import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useVehiclesChartsDataContext } from './hooks/useVehiclesChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const YearAnualList = () => {
    const { chartData } = useVehiclesChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_registro_bo',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'ano_modelo',
                header: 'Ano do Modelo',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.yearAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.anos_modelo.map((ano_modelo) => ({
            ...ano_modelo,
            ano_registro_bo: itemAno.ano_registro_bo
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Ano do Veiculo - Anual"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};